import { deriveOriginLink } from '~support-at-home/lib/derive';

import { faEdit } from '~components/icon';
import { Column } from '~components/table-view-v3';
import { linkCellRender } from '~components/table-view-v3/columnRenderers';

export const columnsFactory = (navigateToClaim: (id: string) => void): Column[] => {
  const columns: Column[] = [
    {
      id: 'claim_item_status',
      header: 'Status',
      type: 'readonly',
    },
    {
      id: 'reference',
      header: 'Ref.',
      type: 'readonly',
    },
    {
      id: 'claim_reference',
      header: 'Claim ID',
      type: 'readonly',
      renderReadOnly: linkCellRender((row) => navigateToClaim(String(row.claim_id)), faEdit),
    },
    {
      id: 'recon_reference',
      header: 'Recon ID',
      type: 'readonly',
    },
    {
      id: 'statement_reference',
      header: 'Statement ID',
      type: 'readonly',
    },
    {
      id: 'service_date',
      header: 'Service Date',
      type: 'date',
    },
    {
      id: 'client_name',
      header: 'Client Name',
      type: 'readonly',
    },
    {
      id: 'client_naps_service_id',
      header: 'ACAMPS #',
      type: 'readonly',
      classNames: {
        header: 'cell-align-right',
        column: 'cell-align-right',
      },
    },
    {
      id: 'sah_service_type',
      header: 'SAH Service Type',
      type: 'readonly',
    },
    {
      id: 'tp_service_type',
      header: 'TP Service Type',
      type: 'readonly',
    },
    {
      id: 'qty',
      header: 'QTY',
      type: 'number',
      classNames: {
        header: 'cell-align-right',
        column: 'cell-align-right',
      },
    },
    {
      id: 'total',
      header: 'Total',
      type: 'currency',
      classNames: {
        header: 'cell-align-right',
        column: 'cell-align-right',
      },
    },
    {
      id: 'invoice_amount',
      header: 'Inv Total',
      type: 'currency',
      deriveValue: (row) => (row.origin_tag === 'invoice' ? row.invoice_amount : null),
      classNames: {
        header: 'cell-align-right',
        column: 'cell-align-right',
      },
    },
    {
      id: 'funding_type',
      header: 'Funding Type',
      type: 'readonly',
    },
    {
      id: 'origin_link',
      header: 'Origin Link',
      type: 'readonly',
      deriveValue: (row) => (deriveOriginLink(row) ? row.origin_tag : null),
      renderReadOnly: linkCellRender((row) => {
        const link = deriveOriginLink(row);
        if (link) window.open(link, '_blank', 'noopener,noreferrer');
      }, faEdit),
    },
  ];

  return columns;
};
